import {DriverFilters} from './../model/driver';
import {
  Http,
  Response,
  Headers,
  Request,
  RequestOptions,
} from '@angular/http';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {AuthHeaderService} from '../views/authheader.service';
import {environment} from '../../environments/environment';
import {Injectable} from '@angular/core';
import {map, catchError} from 'rxjs/operators';

@Injectable()
export class DriversService {
  driversurl: string;
  driversavalurl: string;

  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.driversurl = environment.driversurl;
    this.driversavalurl = environment.driversavalurl;
  }

  SendForm(pageFilters: DriverFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    // console.log(JSON.stringify(options));
    return this.http.post(this.driversurl, pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getDriversData(query?) {
    let url = this.driversurl;
    // if(query?.startDateTime){
    //   url = url + `?startDateTime=${query?.startDateTime}`
    // }
    // if(query?.jobId){
    //   url = url + `&jobId=${query?.jobId}`
    // }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getDriversAvaialbleData(st) {
    let url = this.driversavalurl;
      url = url + (st ?`?fromDate=${st}`:'')
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getJobsByDriverId(driverId: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    const url = `${this.driversurl}/${driverId}/jobs`;
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  EditDrivers(obj, id) {
    delete obj['_id'];
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.driversurl + '/' + id, obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  DeleteDrivers(_id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.delete(this.driversurl + '/' + _id, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
}
